export enum EActionNames {
  ADD_SHELF = 'ADD_SHELF',
  ADD_BOX = 'ADD_BOX',
  ADD_FRUIT = 'ADD_FRUIT',
  CHANGE_CONTAINER = 'CHANGE_CONTAINER',
  CHANGE_TREE_MAPPED = 'CHANGE_TREE_MAPPED',
  CHANGE_DRAGGING_ELEMENT = 'CHANGE_DRAGGING_ELEMENT',
  SORT_ELEMENTS = 'SORT_ELEMENTS'
}

export enum EFruits {
  LEMON = 'LEMON',
  ORANGE = 'ORANGE',
  KIWI = 'KIWI'
}




// WEBPACK FOOTER //
// ./src/store/enums.ts